import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: '94%',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: 40,
      marginBottom: 100,
    },
    root: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      [theme.breakpoints.up('xs')]: {
        width: '100%',
      },
      [theme.breakpoints.up('md')]: {
        width: '100%',
      },
      [theme.breakpoints.up('lg')]: {
        width: '100%',
      },
    },
    rightitem: {
      marginRight: 48,
    },
    tableMargin: {
      margin: 21,
    },
    mAuto: {
      margin: 'auto',
    },
    input: {
      marginLeft: theme.spacing(1),
      width: '100%',
    },
    iconButton: {
      padding: 10,
    },
    divider: {
      height: 28,
      margin: 4,
    },
    btnPrimary: {
      minHeight: 38,
      height: 38,
      width: 38,
      minWidth: 38,
      textTransform: 'none',
      background:
        'transparent linear-gradient(230deg, #FFDC27 0%, #E63C3C 50%, #000A8C 100%) 0% 0% no-repeat padding-box',
      color: '#fff',
      '@media(min-width: 1250px)': {
        minHeight: 48,
        height: 48,
        width: 146,
        minWidth: 146,
      },
    },

    flexCenterY: {
      display: 'flex',
      alignItems: 'center',
    },
    bodycenter: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
    },
    marginLeft: {
      marginLeft: 21,
      textTransform: 'none',
    },
    btnPrimaryC: {
      borderWidth: '1px',
      borderStyle: 'solid',
      borderImage: 'linear-gradient(to top, #000A8C  50% , #E63C3C 0% , #FFDC27 100%) 1',
      color: '#0E1247',
      width: 'auto',
      // minWidth: 'fit-content',
      backgroundColor: '#FFFFFF',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 10,
      padding: '12px 16px',
      textTransform: 'none',
      fontFamily: 'Poppins',
      fontSize: '14px',
      fontWeight: 500,
      '& svg': {
        marginRight: '11px',
      },
    },
    detailsContainer: {
      margin: 0,
      padding: '20px',
      background: 'white',
      borderRadius: '10px',
    },
    detailsTitle: {
      color: '#000A8C',
      fontSize: '12px',
      fontWeight: 600,
      textTransform: 'none',
      background: '#F7F7FB',
      padding: '10px',
      textAlign: 'center',
      whiteSpace: 'nowrap',
      display: 'inline-block',
      width: 'fit-content',
      marginRight: '40px',
    },
    infoTitle: {
      color: '#5763FF',
      fontSize: '10px',
      fontFamily: 'Poppins',
      fontWeight: 'bold',
      textTransform: 'none',
    },
    infoText: {
      color: '#0E1247',
      fontSize: '12px',
      fontFamily: 'Poppins',
      textTransform: 'none',
      fontWeight: 400,
    },
    infoContainer: {
      marginRight: '40px',
    },
    backLink: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      marginBottom: 16,
      padding: 0,
      border: 'none',
      background: 'transparent',
      color: '#383838',
      fontFamily: 'Poppins',
      fontSize: 15,
      fontWeight: 500,
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    titleRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 12,
      marginBottom: 20,
      flexWrap: 'wrap',
    },
    pageTitle: {
      fontFamily: 'Poppins',
      fontSize: 32,
      fontWeight: 500,
      color: '#000B33',
      margin: 0,
      letterSpacing: '-0.02em',
    },
    actionBtn: {
      background: '#000A8C',
      color: '#FFFFFF',
      textTransform: 'none',
      fontFamily: 'Poppins',
      fontWeight: 500,
      fontSize: 14,
      borderRadius: 8,
      padding: '10px 16px',
      boxShadow: 'none',
      whiteSpace: 'nowrap',
      '&:hover': {
        background: '#000A8D',
        boxShadow: 'none',
      },
    },
    emptyStateContent: {
      textAlign: 'center',
      maxWidth: '600px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '24px',
    },
    emptyStateTitle: {
      fontFamily: 'Poppins',
      fontWeight: 600,
      fontSize: '24px',
      lineHeight: '100%',
      color: '#1A1A1A',
      margin: 0,
    },
    emptyStateSubtitle: {
      fontFamily: 'Poppins',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '140%',
      color: '#6B7280',
      margin: 0,
    },
    tableContainer: {
      margin: '15px 0',
      width: '100%',
    },
    consultationTable: {
      '& .MuiTable-root': {
        tableLayout: 'auto',
      },
      '& .MuiTableHead-root': {
        backgroundColor: '#23296f',
      },
      '& .MuiTableHead-root .MuiTableCell-head': {
        backgroundColor: '#23296f',
        color: '#FFFFFF',
        fontFamily: 'Poppins',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '100%',
        letterSpacing: '0%',
        textTransform: 'uppercase',
        padding: '16px 20px',
        borderBottom: 'none',
        textAlign: 'left',
        '&:nth-child(1)': {
          width: '140px',
        },
        '&:nth-child(2)': {
          width: 'auto',
        },
        '&:nth-child(3)': {
          width: '180px',
        },
        '&:nth-child(4)': {
          width: '200px',
        },
        '&:nth-child(5)': {
          width: '120px',
        },
        '&:nth-child(6)': {
          width: 'auto',
        },
      },
      '& .MuiTableBody-root .MuiTableRow-root': {
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: '#F8FAFF',
        },
      },
      '& .MuiTableBody-root .MuiTableCell-body': {
        fontFamily: 'Poppins',
        fontWeight: 400,
        fontSize: '14px',
        color: '#1A1A1A',
        padding: '16px 20px',
        borderBottom: '1px solid #E5E7EB',
        textAlign: 'left',
      },
      '& .MuiTableRow-root:last-child .MuiTableCell-body': {
        borderBottom: 'none',
      },
    },
    emptyTable: {
      '& .MuiTableBody-root': {
        display: 'none !important', // Hide table body completely when empty
      },
      '& .MuiTableContainer-root': {
        paddingBottom: '0 !important',
        minHeight: 'auto !important',
        height: 'auto !important',
      },
      '& .MuiTable-root': {
        marginBottom: '0 !important',
      },
      // Remove any empty row spacing
      '& .tableCellEmpty': {
        display: 'none !important',
      },
    },
    emptyStateSection: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '60px 20px',
      marginBottom: '100px',
      backgroundColor: 'white',
      // Responsive bottom margin
      [theme.breakpoints.down('md')]: {
        marginBottom: '60px', // Smaller margin on tablets
      },
      [theme.breakpoints.down('sm')]: {
        marginBottom: '40px', // Even smaller margin on mobile
      },
    },
    // Drawer content styles
    stepIndicator: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: '40px',
      gap: '16px',
    },
    step: {
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'Poppins',
      fontWeight: 600,
      fontSize: '16px',
    },
    stepActive: {
      backgroundColor: '#23296f',
      color: 'white',
    },
    stepInactive: {
      backgroundColor: '#E5E7EB',
      color: '#9CA3AF',
    },
    stepConnector: {
      width: '40px',
      height: '2px',
      backgroundColor: '#E5E7EB',
      alignSelf: 'center',
    },
    mainTitle: {
      fontFamily: 'Poppins',
      fontWeight: 600,
      fontSize: '18px',
      lineHeight: '28px',
      letterSpacing: '0%',
      textAlign: 'left',
      marginBottom: '16px',
      color: '#151528',
    },
    contextLabel: {
      fontFamily: 'Poppins',
      fontWeight: 500,
      fontSize: '14px',
      color: '#0E1247',
      marginTop: '24px',
    },
    subtitle: {
      fontFamily: 'Poppins',
      fontWeight: 400,
      fontSize: '14px',
      letterSpacing: '0%',
      textAlign: 'left',
      color: '#151528',
      marginBottom: '24px',
    },
    testList: {
      marginBottom: '32px',
    },
    testItem: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '16px',
      gap: '16px',
    },
    testIcon: {
      width: '24px',
      height: '24px',
      borderRadius: '50%',
      backgroundColor: '#FEE2E2',
      color: '#DC2626',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: '12px',
      fontSize: '14px',
      fontWeight: 'bold',
    },
    testName: {
      fontFamily: 'Poppins',
      fontWeight: 500,
      fontSize: '14px',
      color: '#0E1247',
      flex: 1,
      height: '52px',
      padding: '5px 15px',
      border: '1px solid #CDCEDA',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
    },
    testNameCompleted: {
      backgroundColor: '#5763FF14',
      borderColor: '#CDCEDA',
    },
    testNameIncomplete: {
      backgroundColor: 'white',
      borderColor: '#E5E7EB',
    },
    testNameNotDone: {
      backgroundColor: 'rgba(230, 60, 60, 0.08)',
      borderColor: '#CDCEDA',
    },
    // Form styles for step 2
    formContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '30px',
      marginBottom: '32px',
    },
    formField: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    },
    formLabel: {
      fontFamily: 'Poppins',
      fontWeight: 500,
      fontSize: '14px',
      color: '#1f2937',
      gap: '8px',
    },
    optionalLabel: {
      fontWeight: 400,
      color: '#9CA3AF',
      fontSize: '12px',
      float: 'right',
    },
    formInput: {
      padding: '12px 16px',
      border: '1px solid #D1D5DB',
      borderRadius: '8px',
      fontSize: '14px',
      fontFamily: 'Poppins',
      color: '#374151',
      backgroundColor: 'white',
      '&:focus': {
        outline: 'none',
        borderColor: '#3B82F6',
        boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.1)',
      },
      '&::placeholder': {
        color: '#9CA3AF',
      },
    },
    formSelect: {
      width: '100%',
      '& .MuiOutlinedInput-root': {
        borderRadius: '8px',
        fontSize: '14px',
        fontFamily: 'Poppins',
        backgroundColor: 'white',
        '& fieldset': {
          borderColor: '#D1D5DB',
        },
        '&:hover fieldset': {
          borderColor: '#3B82F6',
        },
        '&.Mui-focused fieldset': {
          borderColor: '#3B82F6',
          boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.1)',
        },
      },
      '& .MuiSelect-select': {
        padding: '12px 16px',
        paddingRight: '40px',
        fontFamily: 'Poppins',
        fontSize: '14px',
        color: '#374151',
      },
      '& .MuiSelect-icon': {
        color: '#6B7280',
        right: '12px',
        fontSize: '20px',
      },
    },
    selectInput: {
      '&.MuiSelect-root': {
        fontFamily: 'Poppins',
        fontSize: '14px',
      },
    },
    placeholder: {
      color: '#9CA3AF',
      fontStyle: 'italic',
    },
    bottomMessage: {
      fontFamily: 'Poppins',
      fontWeight: 400,
      fontSize: '14px',
      textAlign: 'center',
      marginBottom: '32px',
      color: '#151528',
      lineHeight: '20px',
      letterSpacing: '0%',
      maxWidth: '488px',
      minHeight: '40px',
      margin: '0 auto 32px auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0 16px',
    },
    // Base button styles - shared properties
    baseButton: {
      fontFamily: 'Poppins',
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '160%',
      letterSpacing: '0%',
      textTransform: 'none',
      textAlign: 'center',
      padding: '12px 24px',
      borderRadius: '3px',
      height: '43px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      border: 'none',
      '& .MuiButton-label': {
        margin: 'auto',
        marginTop: '0 !important',
      },
    },

    actionButton: {
      backgroundColor: '#000A8C',
      color: '#FFFFFF',
      minWidth: '164px',
      minHeight: '44px',
      '&:hover': {
        backgroundColor: '#1a1f5a',
      },
    },
    buttonContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '12px',
      width: '100%',
    },
    primaryButton: {
      backgroundColor: '#000A8C',
      width: '100%',
      color: '#FFFFFF',
      '&:hover:not(:disabled)': {
        backgroundColor: '#1a1f5a',
      },
      '&:disabled': {
        backgroundColor: '#E5E7EB',
        color: '#9CA3AF',
        cursor: 'not-allowed',
      },
      '& .MuiButton-label': {
        margin: '0 !important',
      },
      [theme.breakpoints.down('lg')]: {
        padding: 0,
      },
    },
    secondaryButton: {
      backgroundColor: 'white',
      width: '100%',
      color: '#23296f',
      border: '1px solid #23296f',
      overflow: 'hidden !important',
      '&:hover': {
        backgroundColor: '#f8f9ff',
      },
      [theme.breakpoints.down('lg')]: {
        padding: 0,
      },
      '& .MuiButton-label': {
        margin: '0 !important',
      },
    },
    modalContentWrapper: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      maxHeight: '91vh',
      minHeight: '500px',
      justifyContent: 'space-between',
    },
    mainContent: {
      flex: 1,
      overflow: 'auto',
      paddingBottom: '5px',
    },
    bottomContainer: {
      marginTop: 'auto',
      paddingTop: '20px',
      paddingBottom: '20px',
      flexShrink: 0,
    },
    // Step indicator styles - Responsive
    stepIndicatorContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: '35px',
      marginBottom: '45px',
      width: '100%',
      maxWidth: '100%',
      overflow: 'hidden',
      [theme.breakpoints.down('sm')]: {
        marginTop: '24px',
        marginBottom: '24px',
        padding: '0 8px',
      },
    },
    stepCircle: {
      width: '36px',
      height: '36px',
      minWidth: '36px',
      minHeight: '36px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'Poppins',
      fontWeight: 600,
      fontSize: '13px',
      lineHeight: '1',
      flexShrink: 0,
      position: 'relative',
      zIndex: 2,
      [theme.breakpoints.down('md')]: {
        width: '28px',
        height: '28px',
        minWidth: '28px',
        minHeight: '28px',
        fontSize: '12px',
      },
      [theme.breakpoints.down('sm')]: {
        width: '24px',
        height: '24px',
        minWidth: '24px',
        minHeight: '24px',
        fontSize: '11px',
      },
    },
    stepCircleActive: {
      backgroundColor: '#5763FF',
      color: 'white',
    },
    stepCircleInactive: {
      backgroundColor: '#E5E7EB',
      color: '#9CA3AF',
    },
    stepConnectorLine: {
      width: '65px',
      height: '2px',
      backgroundColor: '#D1D5DB',
      flexShrink: 1,
      position: 'relative',
      zIndex: 1,
      marginLeft: '-2px',
      marginRight: '-2px',
    },
    // Test checkbox styles
    testCheckbox: {
      width: '50px',
      height: '61px',
      border: '1px solid',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '14px',
      fontWeight: 'normal',
      flexShrink: 0,
      position: 'relative',
      '& .checkIcon': {
        width: '20px',
        height: '20px',
        position: 'absolute',
        top: '21px',
        left: '15px',
      },
    },
    testCheckboxCompleted: {
      backgroundColor: '#5763FF',
      color: 'white',
    },
    testCheckboxIncomplete: {
      backgroundColor: 'white',
      borderColor: '#E5E7EB',
      color: '#9CA3AF',
    },
    testCheckboxNotDone: {
      backgroundColor: '#E63C3C',
      borderColor: '#E63C3C',
      color: 'white',
    },

    // Step 4 - Consultation question styling
    consultationQuestion: {
      fontFamily: 'Poppins',
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '100%',
      letterSpacing: '0%',
      textAlign: 'left',
      color: '#0E1247',
      marginBottom: '10px',
    },

    // Step 4 - Consultation type cards
    consultationOptions: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      marginTop: '24px',
    },
    consultationCard: {
      height: '48px',
      padding: '14px 15px',
      borderRadius: '4px',
      border: '1px solid',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      boxSizing: 'border-box',
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      },
    },
    consultationCardSelected: {
      borderColor: '#5763FF',
      backgroundColor: '#5763FF',
      color: '#FFFFFF',
    },
    consultationCardUnselected: {
      borderColor: '#CDCEDA',
      backgroundColor: '#FFFFFF',
      color: '#0E1247',
      '&:hover': {
        borderColor: '#5763FF',
        backgroundColor: '#F8FAFF',
      },
    },
    consultationCardText: {
      fontFamily: 'Poppins',
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '160%',
      color: 'inherit',
      textAlign: 'left',
    },

    // Step 5 - Context textarea
    contextTextarea: {
      width: '100%',
      minHeight: '120px',
      padding: '16px',
      borderRadius: '4px',
      border: '1px solid #CDCEDA',
      fontFamily: 'Poppins',
      fontSize: '14px',
      lineHeight: '160%',
      color: '#0E1247',
      backgroundColor: '#FFFFFF',
      resize: 'vertical',
      outline: 'none',
      boxSizing: 'border-box',
      '&:focus': {
        borderColor: '#5763FF',
        boxShadow: '0 0 0 2px rgba(87, 99, 255, 0.1)',
      },
      '&::placeholder': {
        color: '#9CA3AF',
        fontStyle: 'italic',
      },
    },

    // CV Upload styles
    cvUploadContainer: {
      width: '100%',
    },
    cvUploadBox: {
      width: '99%',
      height: '120px',
      border: '2px dashed #CDCEDA',
      borderRadius: '8px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      backgroundColor: '#FFFFFF',
      transition: 'all 0.2s ease',
      '&:hover': {
        borderColor: '#5763FF',
        backgroundColor: '#F8FAFF',
      },
    },
    cvUploadIcon: {
      marginBottom: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '40px',
      height: '40px',
      borderRadius: '16px',
      backgroundColor: '#EDEEF2',
    },
    cvUploadText: {
      fontFamily: 'Poppins',
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '24px',
      letterSpacing: '0px',
      color: '#0E1247',
      textAlign: 'center',
    },
    cvUploadFormatText: {
      fontFamily: 'Poppins',
      fontWeight: 500,
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: '0px',
      color: '#9799B1',
      textAlign: 'center',
    },
    cvUploadBoxDragOver: {
      borderColor: '#5763FF',
      backgroundColor: '#F8FAFF',
    },
    cvUploadError: {
      fontFamily: 'Poppins',
      fontWeight: 400,
      fontSize: '12px',
      color: '#E63C3C',
      textAlign: 'center',
      marginTop: '8px',
    },
    // File display styles
    cvFileDisplay: {
      /* width: '94.5%', */
      height: '48px',
      border: '1px solid #CDCEDA',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      padding: '0 16px',
      backgroundColor: '#FFFFFF',
      gap: '12px',
    },
    cvFileIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    },
    cvFileName: {
      fontFamily: 'Poppins',
      fontWeight: 500,
      fontSize: '14px',
      color: '#0E1247',
      flex: 1,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    cvFileDelete: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      padding: '4px',
      borderRadius: '4px',
      '&:hover': {
        backgroundColor: '#F3F4F6',
      },
    },
    drawerTitle: {
      color: '#0E1247',
    },
    button: {
      padding: '12px 20px',
      border: '1.5px solid #CDCEDA',
      borderRadius: '4px',
      height: '32px',
      '& .MuiButton-label': {
        textTransform: 'none',
        color: '#23296F',
        paddingTop: '2px',
      },
    },
  })
);
